<p>Access to the AAOS Resident Management Portal is limited to Residency Program Coordinators
     and Directors. If you need additional help, contact our 
     <a href="https://www.aaos.org/contact-us?_ga=2.175643106.1538936250.1614610390-1803570578.1612466535&ssopc=1">Customer Service Team</a>.</p>
